import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';
import Input from 'components/Input';
import DatePickerComponent from 'components/DatePicker';
import { useNextHandler } from 'features/Croptimizer/providers/NextHandlerContext';
import { scrollTop } from 'utils/scroll-top';

import SupplyPlanTable from './components/SupplyPlanTable';

interface Props {
  isPDF?: boolean;
}

const SupplyPlan = ({ isPDF }: Props) => {
  const { setActiveTab, farm, setFarm, startDate, setStartDate } =
    useCroptimizer();
  const { t } = useTranslation();
  const { setHandler, setShowBack, setShowNext, setBackHandler } =
    useNextHandler();
  const reactNativeWebView = (window as any)?.ReactNativeWebView;

  useEffect(() => {
    // Configure navigation handlers for the current step and enable Back/Next buttons

    setShowBack(true);
    setShowNext(true);

    setBackHandler(() => {
      setActiveTab(3);
      scrollTop();
    });

    setHandler(() => {
      setActiveTab(5);
      scrollTop();
    });
  }, []);

  return (
    <div
      className={`border border-primitiveGrey rounded-2xl mb-6 flex flex-col p-8 ${
        !isPDF && 'md:p-4'
      }`}
    >
      <div className="text-black font-bold mb-8 text-xl md:text-lg md:mt-2">
        {t('farmSupplyPlan')}
      </div>
      <div className="flex mx-[-0.5rem] mb-8">
        <div className="w-4/6 md:w-1/2 px-2">
          <Input
            className="w-full"
            title={t('farmName')}
            titleClassName="bg-white top-[-9px] left-[8px] truncate max-w-[85%]"
            value={farm}
            onChange={setFarm}
            placeholder={t('farm')}
          />
        </div>
        <div className="w-2/6 sm:w-1/2 px-2">
          <DatePickerComponent
            selected={startDate}
            onChange={setStartDate}
            title={t('date')}
            isPDF={isPDF}
            reactNativeWebView={reactNativeWebView}
          />
        </div>
      </div>
      <div>
        <SupplyPlanTable isPDF={isPDF} />
      </div>
    </div>
  );
};

export default SupplyPlan;
